import type {
  ApiDeepRequiredRequestBody,
  ApiRequestBody,
} from "@/lib/api/api-type-helper";
import type { TFunction } from "@/lib/i18n";
import type { EnumUnion } from "@dresscode-frontend/utility-types";

export const CustomSaasType = {
  CUSTOM_SAAS: "CUSTOM_SAAS",
} as const;
export type CustomSaasType = EnumUnion<typeof CustomSaasType>;

export const CustomSaasCategory = {
  COMMUNICATION: "COMMUNICATION",
  DESIGN: "DESIGN",
  DEVELOPMENT: "DEVELOPMENT",
  STORAGE: "STORAGE",
  FINANCE_AND_ACCOUNTING: "FINANCE_AND_ACCOUNTING",
  GENERAL_AFFAIRS: "GENERAL_AFFAIRS",
  HUMAN_RESOURCES: "HUMAN_RESOURCES",
  IT_SECURITY: "IT_SECURITY",
  LEGAL: "LEGAL",
  MARKETING: "MARKETING",
  PROJECT_MANAGEMENT: "PROJECT_MANAGEMENT",
  SALES_CRM: "SALES_CRM",
} as const satisfies Record<
  NonNullable<
    ApiRequestBody<"/v2/apps/install-custom-app", "post">["category"]
  >,
  string
>;
export type CustomSaasCategory = EnumUnion<typeof CustomSaasCategory>;

export const CustomSaasCategoryOptions = (
  t: TFunction<"translation", "pages.software.customSaas.category">,
) => [
  {
    id: CustomSaasCategory.COMMUNICATION,
    label: t("communication"),
  },
  {
    id: CustomSaasCategory.DESIGN,
    label: t("design"),
  },
  {
    id: CustomSaasCategory.DEVELOPMENT,
    label: t("development"),
  },
  {
    id: CustomSaasCategory.STORAGE,
    label: t("storage"),
  },
  {
    id: CustomSaasCategory.FINANCE_AND_ACCOUNTING,
    label: t("finance_and_accounting"),
  },
  {
    id: CustomSaasCategory.GENERAL_AFFAIRS,
    label: t("general_affairs"),
  },
  {
    id: CustomSaasCategory.HUMAN_RESOURCES,
    label: t("human_resources"),
  },
  {
    id: CustomSaasCategory.IT_SECURITY,
    label: t("it_security"),
  },
  {
    id: CustomSaasCategory.LEGAL,
    label: t("legal"),
  },
  {
    id: CustomSaasCategory.MARKETING,
    label: t("marketing"),
  },
  {
    id: CustomSaasCategory.PROJECT_MANAGEMENT,
    label: t("project_management"),
  },
  {
    id: CustomSaasCategory.SALES_CRM,
    label: t("sales_crm"),
  },
];

export const CustomSaasPricingMethod = {
  FREE: "FREE",
  FIXED: "FIXED",
  LINEAR: "LINEAR",
} as const satisfies Record<
  ApiRequestBody<"/v2/apps/install-custom-app", "post">["pricingMethod"],
  string
>;
export type CustomSaasPricingMethod = EnumUnion<typeof CustomSaasPricingMethod>;

export const CustomSaasCurrency = {
  JPY: "JPY",
  USD: "USD",
  IDR: "IDR",
  THB: "THB",
  VND: "VND",
  CNY: "CNY",
} as const satisfies Record<
  ApiDeepRequiredRequestBody<
    "/v2/apps/install-custom-app",
    "post"
  >["subscription"]["currency"],
  string
>;
export type CustomSaasCurrency = EnumUnion<typeof CustomSaasCurrency>;

export const CustomSaasCycleUnit = {
  MONTH: "MONTH",
  YEAR: "YEAR",
} as const satisfies Record<
  ApiDeepRequiredRequestBody<
    "/v2/apps/install-custom-app",
    "post"
  >["subscription"]["cycleUnit"],
  string
>;
export type CustomSaasCycleUnit = EnumUnion<typeof CustomSaasCycleUnit>;
